import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteWarehouseLayout = {
  name: "deleteWarehouseLayout" as const,
  input: z.object({ layoutId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
